import { Link } from "react-router-dom";
import styled from "styled-components";
import { colorTheme } from "../../theme";

export const TileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 700px;
  height: 400px;
  border: 1px solid ${colorTheme.divider};
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  box-sizing: border-box;
  overflow: hidden;
`;

export const Container = styled.div`
  padding: 0 34px;
  max-width: 1440px;
  width: 100%;
  height: 100%;
  place-self: center;
  box-sizing: border-box;
`;

export const TitleLink = styled(Link)`
  text-decoration: none;
  color: ${colorTheme.newBlue};
`;
